<template>
  <!--
    Code By     : 陈伦刚
    CreateTime  : 2020-11-25 03:36:09
    Description : 素材root页面
  -->
  <div class="index">
    <gaia-header @upload="$refs.dialog.show()" />
    <router-view :key="$route.fullPath" />
    <gaia-footer />
    <materialDialog ref="dialog" />
  </div>
</template>
<script>
import gaiaHeader from "@/components/gaia-header/gaia-header";
import GaiaFooter from "@/components/gaia-footer/gaia-footer";
import materialDialog from "@/components/gaia-header/material-dialog";
export default {
  components: {
    gaiaHeader,
    GaiaFooter,
    materialDialog,
  },
  created() {
    if (this.$route.path === "/material") {
      console.log('material-list')
      this.$router.push("/material/list");
    }
  },
};
</script>

<style lang="less" scoped>
</style>
